import { useContext } from 'react'

import WizardContext from '~/ui/components/modals/wizard/context'

export const useWizardProps = () => {
  const { close, step, handleStep, goToKey, goTo, content, reset } = useContext(WizardContext)

  return { close, step, handleStep, goToKey, goTo, content, reset }
}
